import React from "react";
import styles from "./SavedPlace.module.scss";

import heartSvg from "./../../assets/images/icons/heart.svg";
import { ISavedPlace } from "../../models/SavedPlace";

interface SavedPlaceProps {
  place: ISavedPlace;
  onPress: (id: string) => void;
  onPressHeart: (id: string) => void;
}

const SavedPlace: React.FC<SavedPlaceProps> = ({ place, onPress, onPressHeart }) => {
  return (
    <li className={styles.savedPlace} onClick={() => onPress(place?.gymListing?.id)}>
      <img
        width={"100%"}
        height={"100%"}
        src={place?.gymListing?.imagePaths[0]}
        alt={`gym-${place.gymListing.businessName}`}
      />

      <img
        src={heartSvg}
        alt="heart"
        className={styles.savedPlaceHeart}
        onClick={(e) => {
          e.stopPropagation();
          onPressHeart(place?.id);
        }}
      />
    </li>
  );
};

export default SavedPlace;
